import { createContext } from 'react';
import { KeyedMutator } from 'swr';
import {
  IAdminOnboardingInfo,
  IAdminOnboardingStep,
  OnboardingStep,
  OnboardingTooltipType,
} from './types';

interface IOnboardingContext {
  /** Are all the onboarding steps complete? */
  areAllStepsComplete: boolean;

  /** Mark the company as having completed onboarding. */
  completeOnboarding: () => void;

  /** Mark the specified onboarding step as complete. */
  completeStep: (step: OnboardingStep) => void;

  /** Returns `true` if the specified onboarding step is complete. */
  getIsStepComplete: (type: OnboardingStep) => boolean;

  /** Returns `true` when the specified onboarding tooltip is active. */
  getIsTooltipActive: (tooltipType: OnboardingTooltipType) => boolean;

  /** `true` when the company has completed onboarding. */
  isOnboardingComplete: boolean;

  /** Type of the next onboarding step. */
  nextOnboardingStep: OnboardingStep;

  /** List of the company's assigned onboarding steps. */
  onboardingSteps: IAdminOnboardingStep[];

  /** Refresh the onboarding info. */
  refreshOnboarding: KeyedMutator<IAdminOnboardingInfo>;
}

export const OnboardingContext = createContext<IOnboardingContext>({
  areAllStepsComplete: undefined,
  completeOnboarding: undefined,
  completeStep: undefined,
  getIsStepComplete: undefined,
  getIsTooltipActive: undefined,
  isOnboardingComplete: undefined,
  nextOnboardingStep: undefined,
  onboardingSteps: [],
  refreshOnboarding: undefined,
});
